import { render, staticRenderFns } from "./ekokrafDetile.vue?vue&type=template&id=6ed9ab71&"
import script from "./ekokrafDetile.vue?vue&type=script&lang=js&"
export * from "./ekokrafDetile.vue?vue&type=script&lang=js&"
import style0 from "./ekokrafDetile.vue?vue&type=style&index=0&id=6ed9ab71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports